import 'babel-polyfill';
window.Vue = require('vue');
Vue.use(require('vue-axios'), require('axios'));
Vue.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken, //$("meta[name=csrf-token]").attr('content'),//
    'X-Requested-With': 'XMLHttpRequest'
};

// == Add New Prototype to Stings to uc first letter == //
String.prototype.ucfirst = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

import collect from 'collect.js';
window.collect = collect;

// == Keep all Helper functions in its own "Plugin" == //
let Helper = require('./helper.js');
Vue.use(Helper);

import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);

// == Imports == //
import Ckeditor from 'vue-ckeditor2'
let algoliasearch = require('algoliasearch');

window.onpopstate = function(event){
    window.rootVue.$eventHub.$emit('keepAlive', () => {
        window.rootVue.$eventHub.$emit('viewLoader', event.state.url);
    });
};

// == Do Root Vue == //
window.rootVue = new Vue({
    el: '#root',
    comments: true,
    data: function () {
        return {
            tmpData: {
                excluded_tags: [],
                tags: [],
                invoice_tags: []
            },
            window: window,
            setCompany: true,
            company: false,
            latest: false,
            client: false,
            WPclient: false,
            mainModel: {}
        };
    },
    mixins: [
        require('./methods/dialog.js'),
        require('./methods/functions.js'),
        require('./methods/wpremote.js'),
        require('./methods/domain.js'),
        require('./methods/email.js'),
        require('./methods/search.js')
    ],
    components: {
        algoliasearch,
        Ckeditor,
        'proposal': require('./view/invoice/proposal.vue').default,
        'coverBlock': require('./view/proposal/coverBlock.vue').default,
        'InputTag': require('./components/InputTag.vue').default,
        'premium': require('./view/create-subscription').default,
        'asana-typeahead': require('./components/asana-project-list').default,
        'login': require('./view/login.vue').default,
        // 'current-site-counter': require('./view/website/current-site-counter').default,
        'find-webmail': require('./view/find-webmail.vue').default,
        'company-panel': require('./components/company-panel.vue').default,
        'notification': require('./components/notification.vue').default,
        'search-form': require('./view/new-search.vue').default,
        'braintree-methods': require('./view/braintree/paymentMethods.vue').default,
        'float-dialog': require('./view/float-dialog.vue').default,
        'latest-notif': require('./components/latest-notif.vue').default,
        'country': require('./components/form/country.vue').default,
        'datatable': require('./components/datatable.vue').default,
        'search-panel': require('./components/search-panel.vue').default,
        'right-panel': require('./view/right-panel.vue').default,
        // 'search-invoices': require('./view/invoice/search-invoices.vue').default,
        // 'search-websites': require('./components/autocomplete/websites.vue').default,
        'client-payment-gateways': require('./view/gateway/client-payment-form.vue').default,
        'email-account': require('./components/email-account.vue').default,
        'email-template': require('./components/default-email-template.vue').default,
        'page-title': require('./components/pageTitle.vue').default,
        'ckeditor': require('./view/ckeditor/ckeditor.vue').default,
        'company-filters': require('./view/company/company-filters.vue').default,
    },
    created(){
        if (typeof window.searchKey !== 'undefined') {
            this.client = algoliasearch('BXYAO4SOLW', window.searchKey);
        }
        if (typeof window.WPsearchKey !== 'undefined') {
            this.WPclient = algoliasearch('BXYAO4SOLW', window.WPsearchKey);
        }
    }
});
